import { create, StoreApi, UseBoundStore } from 'zustand';

export type PopupStore<TPayload> = UseBoundStore<
  StoreApi<{
    open: boolean;
    payload: TPayload | null;
    show: (payload?: TPayload) => void;
    hide: () => void;
  }>
>;

export function createPopupStore<TPayload = void>(): PopupStore<TPayload> {
  return create((set) => ({
    open: false,
    payload: null,
    show: (payload?: TPayload) => set({ open: true, payload: payload ?? null }),
    hide: () => set({ open: false, payload: null }),
  }));
}
